// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1gnCf","right":"styles_right__2Ogy5"};